export function formatRange(start: number, end: number) {
  return `${start} - ${end}`;
}
